import { render, staticRenderFns } from "./dashboard-financeiro.vue?vue&type=template&id=3c95d3d7&scoped=true&"
import script from "./dashboard-financeiro.vue?vue&type=script&lang=js&"
export * from "./dashboard-financeiro.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-financeiro.vue?vue&type=style&index=0&id=3c95d3d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c95d3d7",
  null
  
)

export default component.exports